import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty018 — REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList */
export default function GroupList() {
  return <OtkOptionCatalogList resource="groups" />;
}
